import * as rq from '@tanstack/react-query';

import { deleteUser } from '../queries/__mocked_data__/users-state';

export namespace DeleteUserMutation {
  export type Input = {
    id: string;
  };
  export type Output = void;

  function useMutationFn() {
    return async function mutationFn(input: Input) {
      // Add artificial 500ms delay
      await new Promise((resolve) => setTimeout(resolve, 500));

      const success = deleteUser(input.id);

      if (!success) {
        throw new Error(`Failed to delete user with id ${input.id}`);
      }

      return;
    };
  }

  export function useMutation() {
    const queryClient = rq.useQueryClient();
    const mutationFn = useMutationFn();

    return rq.useMutation<Output, unknown, Input>({
      mutationFn,
      async onSuccess(_, input) {
        await Promise.all([
          queryClient.invalidateQueries({
            queryKey: ['user-management', 'users'],
          }),
          queryClient.invalidateQueries({
            queryKey: ['user-management', 'user', input.id],
          }),
        ]);
      },
    });
  }
}
